
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftBottom0 as ObiThreewayAcuatorGenericInleftBottom0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-bottom-0.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftBottom0 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-bottom-0',
   elementClass: ObiThreewayAcuatorGenericInleftBottom0Element,
   events: {
     
   }
  });
 
 